import { useContext } from 'react'
import type { AuthContextType } from '@/types'
import { authContext } from '../contexts/auth-context'

export const useAuth = (): AuthContextType => {
  const context = useContext(authContext)

  if (!context) {
    throw new Error('useAuth must be used within AuthProvider')
  }

  return context
}
